import Vue from "vue";

/**
 * Toast utility for displaying notifications
 * This provides a direct import alternative to using this._vm.$toast
 */
export const toast = {
  open(options) {
    const defaultOptions = {
      position: "top",
      duration: 3000,
    };

    Vue.prototype.$toast.open({ ...defaultOptions, ...options });
  },

  success(message, options = {}) {
    this.open({
      type: "success",
      message,
      ...options,
    });
  },

  error(message, options = {}) {
    this.open({
      type: "error",
      message,
      ...options,
    });
  },

  info(message, options = {}) {
    this.open({
      type: "info",
      message,
      ...options,
    });
  },

  warning(message, options = {}) {
    this.open({
      type: "warning",
      message,
      ...options,
    });
  },
};

export default toast;
